import React from 'react';

import cn from 'classnames';
import PropTypes from 'prop-types';

import CrumbLink from './CrumbLink';
import CrumbText from './CrumbText';

const Crumb = ({ href, className, ...rest }) => (
  <div className={cn('cr-topbar__crumb', className)}>
    {!href ? <CrumbText {...rest} /> : <CrumbLink href={href} {...rest} />}
  </div>
);

Crumb.propTypes = {
  href: PropTypes.string,
  className: PropTypes.string,
};

export default Crumb;
